import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { AuthLayout } from '@/components/layout/auth-layout'
import { PasskeySetupCard } from '@/features/auth/setup-passkey/passkey-setup-card'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/setup-passkey')({
  component: SetupPasskey,
  validateSearch: searchSchema,
})

function SetupPasskey() {
  return (
    <AuthLayout>
      <PasskeySetupCard />
    </AuthLayout>
  )
}
